export class Sections {
    public static sectionsToHideLabel = [
        "attachments",
        "declarations",
        "PersonalImportSection",
        "communicationAdjastmentSection",
        "communicationRequestSection",
        "ImportDeclarationSection",
        "deliveryCommentTitle",
        "EconomyStandardsExemptPISection"
    ];
}

